export const pluralNumber = ( num, t1, t2, t3 ) => {
	let t = ``;

	if ( num > 99 )
	{
		num += ``;
		num = parseInt( num.substr( num.length - 2 , 2) );
	}

	if ( num === 11 || num === 12 || num === 13 || num === 14 )
	{
		return t3;
	}
	
	switch ( num % 10 )
	{
		case 1:
			t = t1; // `день`
			break;
		case 2:
		case 3:
		case 4:
			t = t2; // t += `дня`;
			break;
		default:
			t = t3; // t += `дней`;
			break;

	}
	
	return t;
};
